/**************************************************
 * Nombre:       Seccion_Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Calendario from "./Componentes/Home_Calendario";
import Testimonios_Portada from "./Componentes/Testimonios_Portada";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Testimonios = () => {


    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Testimonios_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Calendario/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Testimonios